import React, { useMemo } from 'react';
import locales from '../../../../../content.json';
import { getParameterFromURL } from '../../../../../utils/scripts';
import s from './index.module.scss';
import zone from './img/zone.png';
import zoneDark from './img/zoneDark.png';

export const Description = () => {
  const darkTheme = getParameterFromURL('darkTheme');
  
  return (
    <div className={s.wrapper}>
      <ul className={s.list}>
        <li className={s.item1} dangerouslySetInnerHTML={{ __html: locales[window.userLang].pdfUpselling_3}} />
        <li className={s.item2} dangerouslySetInnerHTML={{ __html: locales[window.userLang].pdfUpselling_4}} />
        <img className={s.listImg} src={darkTheme ? zoneDark : zone}  alt="" />
      </ul>

    </div>
  )
}